module.exports = __webpack_public_path__ + "img/blockS4-2.ea2a652f.svg";